import React, {Component} from 'react';
const { connect } = require('react-redux');

import {getCgu} from 'reducers/cgu';

class CguText extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cgu: null,
            lang: this.props.lang
        };

    }

    componentDidMount() {
        this.props.getCgu();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang != nextProps.lang) {
            this.props.getCgu();
            this.setState({lang: nextProps.lang});
        }
    }

    render() {
        let {cgu} = this.props;

        return (
            <div className="content">
            {cgu && cgu.content && <div dangerouslySetInnerHTML={{__html: cgu.content}}></div>}
            </div>
        )
    }

}

export default connect(
    state => ({
        cgu: state.cgu
    }),({
        getCgu: getCgu
    })
)(CguText)


// WEBPACK FOOTER //
// ./src/components/cgu/CguText.js